<p-fieldset legend="Shell Courses">
    <p-message severity="secondary"><p-button label="Add Shell Courses" (onClick)="goToAddShellCourse()"/></p-message>  
    <p class="my-4">
        <p-iftalabel>
            <input pInputText [formControl]="searchQuery" autocomplete="off" fluid/> 
            <label>Search...</label>
        </p-iftalabel>   
        <small id="searchQuery-help">Use Module Code/Course Code to search (min 3 characters)</small>
    </p>
    <p class="m-0">
                    <p-table selectionMode="single" 
                    [value]="shellCourses" 
                    size="small" 
                    [loading]="loading()" 
                    stripedRows 
                    showGridlines 
                    [paginator]="true"  
                    [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10,50,100,200,500]" 
                    [(selection)]="selectedShellCourse" 
                    dataKey="id"
                    [lazy]="true" 
                    [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="code" style="width:14.2%">
                                    Code <p-sortIcon field="code"/>
                                </th>
                                
                                <th style="width:10.2%" pSortableColumn="createdAt">Created At <p-sortIcon field="createdAt"/></th>
                                <th style="width:10.2%" pSortableColumn="updatedAt">Updated At <p-sortIcon field="updatedAt"/></th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-shellCourse>
                            <tr [pSelectableRow]="shellCourse">
                                <td>{{ shellCourse.code }}</td>
                                <td>{{ shellCourse.createdAt | date}}</td>
                                <td>{{ shellCourse.updatedAt | date}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
</p-fieldset>

        